import { Box, BoxProps, Grid } from '@chakra-ui/react';

import useSandboxTheme from './useSandboxTheme';

/**
 * Outermost themed container for DevSandbox.
 * Must be rendered inside DevSandboxProvider so it can read resolvedTheme.
 */
const DevSandboxShell = ({ children, useGrid, ...rest }: BoxProps & { useGrid?: boolean }) => {
  const { colors } = useSandboxTheme();

  const Component = useGrid ? Grid : Box;

  return (
    <Component backgroundColor={colors.shellBg} {...rest}>
      {children}
    </Component>
  );
};

export default DevSandboxShell;
